import { palette } from 'app_previous/styles/colors';
import styled, { css } from 'styled-components';

interface AnchorContainerProps {
  selected?: boolean;
}

const selectedStyles = css`
  font-weight: 700;
  color: ${palette.accentBlue};
`;

export const AnchorContainer = styled.span`
  position: relative;
`;

export const ArrowCircle = styled.span`
  position: absolute;
  top: 50%;
  width: 16px;
  height: 16px;
  left: -24px;
  transform: translateY(-50%);
`;

export const AnchorElement = styled.a<AnchorContainerProps>`
  text-decoration: none;
  color: ${palette.greyText};
  font-weight: 300;
  font-size: 1rem;
  transition: all 300ms ease-in-out;

  ${({ selected }) => (!selected ? '' : selectedStyles)}

  &:hover {
    ${selectedStyles}
  }
`;
